<template>
	<div>
		<div
			class="arp-botoes-listagem-itens-ata"
			:class="{ '--flex-end': !hasItens || !temPermissaoEdicao || modoVisualizacao }"
		>
			<div
				v-if="hasItens && temPermissaoEdicao && !modoVisualizacao"
				class="flex-column flex-sm-row d-flex justify-sm-start"
			>
				<menu-acoes
					class="botao-tamanho-arp mr-2"
					:nome-botao="menuAcoesItens.nome"
					:nome="menuAcoesItens.nome"
					cor-icone="--v-error-base"
					icone-primary="add_circle"
					icone-secondary="arrow_drop_down"
					:acoes-menu="menuAcoesItens.itens"
					tamanho-icone-primary="0.9rem"
					tamanho-icone-secondary="0.9rem"
					tamanho-icone-menu="18px"
					@adicionar-documento="abrirOuFecharModalAdicionarDocumento"
					@adicionar-anexo="abrirOuFecharModalNovoAnexo"
				>
				</menu-acoes>
				<menu-acoes
					v-if="isProcessoDigitalAtivo"
					class="botao-tamanho-arp"
					:nome-botao="menuAcoesEmMassa.nome"
					:nome="menuAcoesEmMassa.nome"
					cor-icone="--v-error-base"
					icone-secondary="arrow_drop_down"
					:outlined="true"
					:key="abaSelecionada"
					block
					corDeFundo="grey"
					:acoes-menu="menuAcoesEmMassa.itens"
					tamanho-icone-menu="18px"
					@assinar-documentos="abrirOuFecharModalAssinaturaEletronicaEmLote"
					@juntar-documentos="abrirModalJuntar"
				>
				</menu-acoes>
			</div>
			<div>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Busque por título ou autor"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
				>
				</az-search>
			</div>
		</div>
		<editar-documentos-penalidades-ata-listagem
			:key="abaSelecionada"
			:itens="documentos"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:paginacao="paginacao"
			:ata="infoAta"
			@paginar="setPaginacaoListagem"
			@resetar-page="resetarPaginaListagem"
			@recarregar-listagem-externa="buscarDocumentos"
			@continuar-elaboracao-termo-desentranhamento="tratarEventoContinuarElaboracaoTermoDesentranhamento"
			@criar-termo-desentranhamento="tratarEventoCriarTermoDesentranhamento"
			@convidar-signatarios="tratarEventoConvidarSignatarios"
			@visualizar-signatarios="tratarEventoVisualizarSignatarios"
			@enviar-fornecedor="abrirModalEnviarFornecedorSemBusca"
			:id-ata="idAta"
			:modo-visualizacao="modoVisualizacao"
		></editar-documentos-penalidades-ata-listagem>

		<az-container class="listagem">
			<template-listagem-vazia
				:textos="textosTemplateListagemVazia"
				:total-itens="totalItens"
				@botao-evento="abrirOuFecharModalAdicionarDocumento"
			>
				<template #acoes>
					<menu-acoes
						v-if="temPermissaoEdicao && !modoVisualizacao"
						class="acessar-ata-itens-btn-mais-acoes"
						:nome-botao="menuAcoesItens.nome"
						:nome="menuAcoesItens.nome"
						cor-icone="--v-error-base"
						icone-primary="add_circle"
						icone-secondary="arrow_drop_down"
						:acoes-menu="menuAcoesItens.itens"
						tamanho-icone-primary="0.9rem"
						tamanho-icone-secondary="0.9rem"
						tamanho-icone-menu="18px"
						@adicionar-documento="abrirOuFecharModalAdicionarDocumento"
						@adicionar-anexo="abrirOuFecharModalNovoAnexo"
					>
					</menu-acoes>
				</template>
			</template-listagem-vazia>
		</az-container>

		<div v-if="temPermissaoEdicao">
			<modal-novo-documento
				id="modal-adicionar-documento"
				:idDocPai="Number(idAta)"
				:exibir="exibirModalAdicionarDocumento"
				:tipo-documento="tipoModeloDocumento"
				@salvar-documento="salvarDocumento"
				@fechar-modal="abrirOuFecharModalAdicionarDocumento"
			>
			</modal-novo-documento>

			<modal-novo-anexo
				id="modal-novo-anexo"
				:exibir="exibirModalAdicionarAnexo"
				:infoAnexo="infoAta"
				:tipo-documento="[]"
				@salvar-anexo="salvarAnexo"
				@fechar-modal="abrirOuFecharModalNovoAnexo"
			>
			</modal-novo-anexo>

			<modal-assinatura-signatario
				v-if="exibirModalSignatarios"
				:signatarios="signatarios"
				:exibir="exibirModalSignatarios"
				:titulo="tituloModal"
				@fechar-modal="fecharModalSignatarios"
			></modal-assinatura-signatario>

			<modal-selecao-tipo-assinatura
				:permissao-assinatura-eletronica="permissoes.ataAssinaturaEletronicaCriar"
				:permissao-assinatura-digital="permissoes.ataAssinaturaDigitalCriar"
				@assinar-eletronicamente="realizarAssinaturaEletronicaIndividual"
				@assinar-digitalmente="realizarAssinaturaDigital"
			></modal-selecao-tipo-assinatura>

			<modal-assinatura-eletronica
				v-if="exibirModalAssinaturaEmLote"
				titulo="Assinar Eletronicamente em massa"
				nome-botao-confirmar="Assinar"
				:exibir="exibirModalAssinaturaEmLote"
				@fechar-modal="abrirOuFecharModalAssinaturaEletronicaEmLote"
				@assinar-eletronicamente="realizarAssinaturaEletronicaEmLote"
			></modal-assinatura-eletronica>

			<modal-assinatura-progresso-lote
				v-if="exibirModalNotificacaoAssinaturaEletronicaEmLote"
				:exibir="exibirModalNotificacaoAssinaturaEletronicaEmLote"
				:documentos="assinaturasDocumentosNaoConcluidas"
				@atualizar="atualizarModalAssinaturasNaoConcluidas"
				@fechar-modal="fecharModalNotificacaoAssinaturaEletronicaEmLote"
				@assinar-individualmente-documento="realizarAssinaturaEletronicaIndividual"
				@assinar-eletronicamente-documento-lote="realizarAssinaturaEletronicaEmLote"
			></modal-assinatura-progresso-lote>

			<formulario-assinatura-convite
				v-if="exibirModalConvidarSignatarios"
				:exibir-modal="exibirModalConvidarSignatarios"
				:titulo-modal="tituloModal"
				:titulo-documento="tituloDocumento"
				:id-associacao="idAssociacao"
				@fechar-modal="fecharModal"
				@confirmar-signatarios="convidarSignatarios"
				@excluir-signatario="tratarEventoExcluirSignatario"
				:func-buscar="buscarSignatarios"
			></formulario-assinatura-convite>

			<modal-enviar-fornecedor
				v-if="exibirModalEnviarFornecedor"
				:email-fornecedor="emailFornecedor"
				:id-associacao="idAssociacao"
				:exibir="exibirModalEnviarFornecedor"
				@fechar-modal="fecharModalEnviarFornecedor"
				@enviar-fornecedor="tratarEventoConfirmarEnviarFornecedor"
			></modal-enviar-fornecedor>

			<modal-confirmacao
				:titulo-modal="tituloModal"
				:mensagem="mensagemConfirmacaoModal"
				:subtitulo-modal="subtituloConfirmacaoModal"
				:exibir="exibirModalConfirmacao"
				@confirmar="confirmarAcaoModal"
				@fechar-modal="fecharAcaoModal"
			>
			</modal-confirmacao>
			<modal-informativo
				:mensagem-modal="mensagemInformativoModal"
				:exibir-modal="exibirModalInformativo"
				@confirmar-acao-informativo="fecharModalInformativo"
			></modal-informativo>
		</div>
	</div>
</template>
<script>
import { actionTypes, getterTypes, permissoes, routesNames, situacoes, tipoModeloDocumento } from '@/core/constants'
import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'
import mutationTypes from '@/core/constants/mutation-types'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import ModalNovoDocumento from '@/views/components/documentos/novo-documento/ModalNovoDocumento'
import ModalNovoAnexo from '@/views/components/documentos/novo-anexo/ModalNovoAnexo'
import ModalSelecaoTipoAssinatura from '@/views/components/assinatura/selecao-tipo/ModalSelecaoTipoAssinatura'
import assinatura from '@/views/mixins/assinatura'
import documentoMixin from '@/views/mixins/documento'
import ModalAssinaturaSignatario from '@/views/components/documentos/signatario/visualizar/ModalAssinaturaSignatario'
import FormularioAssinaturaConvite from '@/views/components/documentos/signatario/convite/FormularioAssinaturaConvite'
import convidarSignatarios from '@/views/mixins/signatarios/convidar-signatarios'
import ModalAssinaturaEletronica from '@/views/components/assinatura/eletronica/ModalAssinaturaEletronica'
import ModalAssinaturaProgressoLote from '@/views/components/assinatura/progresso-lote/ModalAssinaturaProgressoLote'
import AssinarEletronicamenteDocAtaLoteInput from '@/core/apiclient/processo-digital/models/AssinarEletronicamenteDocAtaLoteInput'
import validacaoAta from '@/views/mixins/validacaoAta'
import EditarDocumentosPenalidadesAtaListagem from '@/views/pages/ata/acessar/penalidades/documentos/listagem/EdicaoDocumentosPenalidadeAtaListagem'
import MenuAcoes from '@/views/components/MenuAcoes'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia'
import ModalConfirmacao from '@/views/components/ModalConfirmacao'
import ModalInformativo from '@/views/components/ModalInformativo'
import ModalEnviarFornecedor from '@/views/components/documentos/enviar-fornecedor/ModalEnviarFornecedor.vue'
import enviarFornecedor from '@/views/mixins/enviar-fornecedor'

export default {
	name: 'documentos-penalidade-ata',
	components: {
		ModalEnviarFornecedor,
		ModalInformativo,
		ModalConfirmacao,
		TemplateListagemVazia,
		MenuAcoes,
		EditarDocumentosPenalidadesAtaListagem,
		ModalAssinaturaProgressoLote,
		ModalAssinaturaEletronica,
		ModalSelecaoTipoAssinatura,
		ModalNovoAnexo,
		ModalNovoDocumento,
		ModalAssinaturaSignatario,
		FormularioAssinaturaConvite,
	},
	mixins: [assinatura, documentoMixin, convidarSignatarios, validacaoAta, enviarFornecedor],
	props: {
		idAta: {
			type: [String, Number],
			required: true,
		},
		modoVisualizacao: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			documentos: [],
			signatarios: [],
			totalItens: 0,
			exibirModalSignatarios: false,
			exibirModalConvidarSignatarios: false,
			exibirModalConfirmacao: false,
			exibirModalEnviarFornecedor: false,
			tituloDocumento: '',
			tituloModal: '',
			subtituloConfirmacaoModal: '',
			mensagemConfirmacaoModal: '',
			totalPaginas: 0,
			paginacao: paginacaoListagem(['id']),
			idAssociacao: null,
			emailFornecedor: '',
			confirmarAcaoModal: () => {},
			fecharAcaoModal: () => {},
			filtroInterno: this.getFiltros(),
			exibirModalAdicionarDocumento: false,
			exibirModalAdicionarAnexo: false,
			textosTemplateListagemVazia: {
				titulo: 'Você não possui documento adicionado',
				mensagem: this.modoVisualizacao ? '' : 'Clique no botão para começar',
			},
			menuAcoesItens: this.getMenuAcoesItens(),
			menuAcoesEmMassa: this.getMenuAcoesEmMassa(),
			tipoModeloDocumento: [tipoModeloDocumento.ATA_REGISTRO_PRECO.value, tipoModeloDocumento.OUTROS.value],
			// eslint-disable-next-line vue/no-unused-properties
			actionsSignatarios: actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS,
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.ata.documentosAta.filtro,
			modalPenalidade: (state) => state.ata.documentosAta.modalPenalidade,
			infoAta: (state) => state.ata.informacoesAta,
			abaSelecionada: (state) => state.penalidades.abaSelecionada,
			documentosSelecionados: (state) => state.ata.documentosAta.documentosSelecionados,
			idPenalidade: (state) => state.penalidades.idPenalidadeSalva,
			isProcessoDigitalAtivo: (state) => state.parametrosSistema.isProcessoDigitalAtivo,
		}),
		...mapGetters({
			cabecalho: getterTypes.ATA.GET_ATA_PARA_CABECALHO,
		}),
		hasItens() {
			return this.totalItens > 0
		},
	},
	watch: {
		abaSelecionada: {
			async handler() {
				if (this.abaSelecionada !== 2) return
				await this.buscarDocumentos()
			},
			immediate: true,
		},
	},
	async mounted() {
		await this.buscarDocumentos()
	},
	methods: {
		async carregarInformacoesDaAta() {
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.$route.params.id)
			await this.montaInformacoes()
		},
		montaInformacoes() {
			this.atualizaCabecalho(this.cabecalho)
		},
		atualizaCabecalho(informacoes) {
			this.$store.commit(mutationTypes.COMUM.SET_INFO_CABECALHO, informacoes)
		},
		buscarSignatarios(idAssociacao) {
			return this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.BUSCAR_SIGNATARIOS, idAssociacao)
		},
		async tratarEventoCriarTermoDesentranhamento(documento) {
			this.setMensagemLoading('Carregando o termo de desentranhamento...')
			const termoDesentranhamento = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.CRIAR_TERMO,
				{ idDocumento: documento.id },
			)

			await this.$router.push({
				name: routesNames.ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
				params: {
					idAta: this.idAta,
					idTermo: termoDesentranhamento.documento.idAssociacao,
				},
			})
		},
		async tratarEventoContinuarElaboracaoTermoDesentranhamento(documento) {
			await this.$router.push({
				name: routesNames.ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
				params: {
					idAta: this.idAta,
					idTermo: documento.idReferenciaTermoDesentranhamento,
				},
			})
		},
		async tratarEventoConfirmarEnviarFornecedor(obj) {
			try {
				await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.ENVIAR_DOCUMENTO_PARA_FORNECEDOR, obj)

				this.mostrarNotificacaoSucessoDefault()
				this.fecharModalEnviarFornecedor()
			} catch (e) {
				this.mostrarNotificacaoErroDefault()
			}
		},
		async buscarDocumentos() {
			this.limparDocumentosSelecionados()
			this.setVariaveisDocumentoPenalidade(this.idPenalidade)

			let { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.BUSCAR_POR_FILTRO,
				this.idAta,
			)

			if (this.isProcessoDigitalAtivo) {
				await this.buscarAssinaturasNaoConcluidasEValidarAssinaturaEmLote()

				this.documentos = await this.buscarSignatariosDocumento(itens)
			} else {
				this.documentos = itens
			}

			this.totalItens = totalElements
			this.totalPaginas = totalPages
			this.setVariaveisDocumentoPenalidade()
		},
		setVariaveisDocumentoPenalidade(value) {
			this.modalPenalidade.idPenalidade = { value }
		},
		async buscarAssinaturasNaoConcluidasEValidarAssinaturaEmLote() {
			this.validarAssinaturaEmLote(await this.buscarAssinaturasNaoConcluidas())
		},
		async atualizarModalAssinaturasNaoConcluidas() {
			this.limparDocumentosAssinaturasNaoConcluidas()
			this.setMensagemLoading('Carregando documentos com assinaturas não concluídas...')
			this.assinaturasDocumentosNaoConcluidas = await this.buscarAssinaturasNaoConcluidas()
		},
		async buscarAssinaturasNaoConcluidas() {
			const { itens } = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.BUSCAR_ASSINATURAS_NAO_CONCLUIDAS,
				this.idAta,
			)
			return itens
		},
		async buscar(searchText) {
			if (searchText) this.filtro.tituloOuAutor.value = searchText
			this.resetarPaginaListagem()
			await this.buscarDocumentos()
		},
		async salvarAnexo() {
			const documentoComAnexo = this.$store.state.campoArquivoNovo.documentoComAnexo
			documentoComAnexo.idPenalidade = this.idPenalidade

			await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.ANEXOS.CRIAR, documentoComAnexo)
			await this.buscarDocumentos()
			this.mostrarNotificacaoSucessoDefault()
			await this.carregarInformacoesDaAta()
		},
		async salvarDocumento(dados) {
			const documento = await this.adicionarDocumento(dados)
			this.mostrarNotificacaoSucessoDefault()
			await this.buscarDocumentos()
			await this.carregarInformacoesDaAta()
			this.redirecionarPara(documento.urlEdicao)
		},
		async adicionarDocumento(dados) {
			dados.idPenalidade = this.idPenalidade
			return await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.ADICIONAR, dados)
		},
		async removerFiltros() {
			if (this.filtro.tituloOuAutor.value) {
				this.filtro.tituloOuAutor.value = this.filtro.tituloOuAutor.default
				this.filtroInterno.tituloOuAutor.value = this.filtroInterno.tituloOuAutor.default
			}
			await this.buscarDocumentos()
		},
		// eslint-disable-next-line vue/no-unused-properties
		async validarSeDocumentoFoiAssinadoNoProcessoDigital(documento) {
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.VALIDAR_DOCUMENTO_ASSINADO,
				documento.id,
			)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async assinarDigitalmenteDocumento(documento) {
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_DIGITALMENTE,
				documento.id,
			)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async assinarEletronicamenteDocumento(documento) {
			this.setMensagemLoading('Assinando documento eletronicamente...')
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE,
				documento.id,
			)
		},
		// eslint-disable-next-line vue/no-unused-properties
		async assinarEletronicamenteDocumentoEmLote(idsDocumentosAssinatura) {
			this.setMensagemLoading('Assinando documentos eletronicamente...')
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE_LOTE,
				new AssinarEletronicamenteDocAtaLoteInput(this.idAta, idsDocumentosAssinatura),
			)
		},
		abrirModalJuntar() {
			if (this.documentosSelecionados.length === 0) {
				this.mostrarNotificacaoErro('Não possui itens para juntar!')
			} else {
				const mensagemJuntarItens =
					'Clique no botão de Confirmar se deseja que os documentos/anexos sejam enviados para o processo digital.'
				const subtituloJuntarItens = 'Gostaria de juntar os documentos ao processo digital?'
				const tituloModalJuntarItens = 'Juntar'

				this.confirmarAcaoModal = this.juntarItensEmMassa
				this.fecharAcaoModal = this.fecharModalJuntar

				this.tituloModal = tituloModalJuntarItens
				this.mensagemConfirmacaoModal = mensagemJuntarItens
				this.subtituloConfirmacaoModal = subtituloJuntarItens

				this.exibirModalConfirmacao = true
			}
		},
		fecharModalJuntar() {
			this.subtituloConfirmacaoModal = ''
			this.exibirModalConfirmacao = false
			this.itemSelecionado = null
		},
		async juntarItensEmMassa() {
			const payload = {
				id: this.infoAta.id,
				idsDocumentos: this.documentosSelecionados.map((item) => item.id),
			}

			await this.$store.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.JUNTAR_LOTE_DOCUMENTOS, payload)
			await this.buscarDocumentos()
			this.fecharModalJuntar()
			this.mostrarNotificacaoSucesso('Documentos foram juntados ao processo digital.')
		},
		limparDocumentosSelecionados() {
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.CHECKBOX.DESFAZER_SELECAO_ITENS_LISTAGEM)
		},
		resetarPaginaListagem() {
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.RESETAR_PAGINA_LISTAGEM)
			this.limparDocumentosSelecionados()
		},
		abrirOuFecharModalAdicionarDocumento() {
			this.exibirModalAdicionarDocumento = !this.exibirModalAdicionarDocumento
		},
		abrirOuFecharModalNovoAnexo() {
			this.exibirModalAdicionarAnexo = !this.exibirModalAdicionarAnexo
		},
		setPaginacaoListagem(paginacao) {
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.SET_PAGINACAO_LISTAGEM, paginacao)
			this.buscarDocumentos()
		},
		getFiltros() {
			return _.cloneDeep(this.$store.state.ata.documentosAta.filtro)
		},
		getMenuAcoesItens() {
			return {
				nome: 'Adicionar',
				itens: [
					{
						titulo: 'Documento',
						icone: {
							nome: 'description',
						},
						evento: 'adicionar-documento',
					},
					{
						titulo: 'Anexo',
						icone: {
							nome: 'attach_file',
						},
						evento: 'adicionar-anexo',
					},
				],
			}
		},
		getMenuAcoesEmMassa() {
			const situacoesAceitas = [situacoes.ATA.EFETIVADO.value, situacoes.ATA.CANCELADO.value]

			const objBotoes = {
				nome: 'MAIS AÇÕES',
				itens: [
					{
						titulo: 'Assinar',
						icone: {
							nome: 'mdi-draw-pen',
						},
						evento: 'assinar-documentos',
						authorization: permissoes.ataAssinaturaEletronicaCriar,
					},
				],
			}

			if (situacoesAceitas.includes(this.$store.state.ata.informacoesAta.situacao)) {
				objBotoes.itens.push({
					titulo: 'Juntar',
					icone: {
						nome: 'mdi-file-replace',
					},
					evento: 'juntar-documentos',
					authorization: permissoes.ataProcessoDigitalJuntarLote,
				})
			}

			return objBotoes
		},
	},
}
</script>
<style lang="stylus" scoped>
.arp-botoes-listagem-itens-ata
	display flex;
	margin 25px 0
	place-content: space-between

.--flex-end
	place-content: flex-end

	> div
		margin-right 15px

.d-flex
	gap: 10px
</style>
